<template>
  <div>
    <transition name="fade">
      <div :key="'delivery_time_dark'" class="pu_dark" v-show="$store.getters.modal.time"></div>
    </transition>
    <transition name="slide">
      <div :key="'delivery_time'" class="pu_bottom popup_click_hide" v-show="$store.getters.modal.time">
        <div class="pu_bottom_scroll">
          <div @click="close" class="pu_b_close"></div>
          <div class="pu_bottom_inner ">
            <template
              v-if="this.$store.getters.outletSettings.delivery_time.today.length !== 0 || this.$store.getters.outletSettings.delivery_time.tomorrow.length !== 0">
              <div class="pu_select" style="display: block">
                <smooth-picker :change="dataChange" :data="data" :style="style" class="time_picker"
                               ref="smoothPicker"/>
              </div>
              <div class="pu_tovar_nav pu_tovar_nav_one">
                <div class="pu_tovar_nav_btn">
                  <a @click="pick()" class="fbb_btn">
                    {{ buttonText }}
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <div style="padding: 20px; text-align: center; font-size: 50px;">
                CLOSED :(
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {SmoothPicker} from 'vue-smooth-picker'
  import 'vue-smooth-picker/dist/css/style.css'
  import * as moment from 'moment'
  import {mapGetters} from 'vuex'
  import {SET_DELIVERY_TIME_OBJECT, SET_MODAL, SET_TIMES} from '@/store/mutations.type'

  export default {
    name: 'DeliveryOneDay',
    components: {
      SmoothPicker
    },
    data() {
      return {
        style: {display: 'block'},
        backupState: {
          pickedDay: null,
          pickedHour: null,
          pickedTime: null
        },

        data: [
          {
            currentIndex: 0,
            flex: 1,
            list: [],
            className: 'row-group'
          },
          {
            currentIndex: 0,
            flex: 1,
            list: [],
            className: 'item-group align-right'
          },
          {
            currentIndex: 0,
            flex: 1,
            list: [],
            className: 'item-group align-left'
          }
        ],

        dayList: [],
        hourList: [],
        timeList: [],

        pickedDay: null,
        pickedHour: null,
        pickedTime: null
      }
    },
    watch: {
      pickedDay: function (pickedDay) {

        this.hourList = []

        let key = null
        let date = null
        if (pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').date()) {
          key = 'today'
          date = moment().locale(this.language).utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd')
        }
        // if (pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').add(1, 'd').date()) {
        //   key = 'tomorrow'
        //   date = moment().locale(this.language).utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').add(1, 'd')
        // }

        let offset = date.utcOffset()
        let bareHours = []

        this.$store.getters.outletSettings.delivery_time[key].map((el) => {

          let data = el

          let time = null
          if (this.$store.getters.timeFormat12) {
            time = moment(el, 'hh:mm A')
          } else {
            time = moment(el, 'HH:mm')
          }
          date.hour(time.hour())
          date.minute(time.minute())
          date.second(0)
          data = date.utcOffset(0).unix()
          date.utcOffset(offset)

          let label = this.$store.getters.timeFormat12 ? date.format('hh') : date.format('HH')
          if (!bareHours.includes(date.format('HH'))) {
            bareHours.push(date.format('HH'))
            this.hourList.push({value: label, data: date.hour()})
          }
        })

      },

      pickedHour: function (pickedHour) {

        this.timeList = []

        let key = null
        let date = null
        if (this.pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').date()) {
          key = 'today'
          date = moment().locale(this.language).utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd')
        }
        // if (this.pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').add(1, 'd').date()) {
        //   key = 'tomorrow'
        //   date = moment().locale(this.language).utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').add(1, 'd')
        // }

        let offset = date.utcOffset()

        let times = []
        this.$store.getters.outletSettings.delivery_time[key].map((el) => {

          let data, time
          if (this.$store.getters.timeFormat12) {
            time = moment(el, 'h:mm A')
          } else {
            time = moment(el, 'HH:mm')
          }
          date.hour(time.hour())
          date.minute(time.minute())
          date.second(0)
          data = date.utcOffset(0).unix()
          date.utcOffset(offset)


          if (date.hour() === pickedHour.data) {
            times.push({
              value: this.$store.getters.timeFormat12 ? date.format('mm A') : date.format('mm'),
              data: data,
              label: this.$store.getters.timeFormat12 ? date.format('h:mm A') : date.format('HH:mm')
            })
          }
        })

        if (
          this.$store.getters.outletSettings.accept_today === true &&
          this.$store.getters.outletSettings.delivery_time.forbidAsFastAsYouCan === false &&
          this.pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).date() &&
          this.hourList[0].data === this.pickedHour.data
        ) {
          times[0].asap = true
        }
        this.timeList = this.timeList.concat(times)

      },

      dayList: function (dayList) {
        if (this.backupState.pickedDay) {
          for (let i in dayList) {
            if (this.pickedDay.value === dayList[i].value) {
              this.pickedDay = dayList[i]
              this.$refs.smoothPicker.setGroupData(0, Object.assign({}, this.data[0], {
                list: dayList,
                currentIndex: Number(i)
              }))
              this.backupState.pickedDay = null
              return
            }
          }
          this.backupState.pickedDay = null
        }
        this.$refs.smoothPicker.setGroupData(0, Object.assign({}, this.data[0], {list: dayList}))
        this.pickedDay = dayList[0]

      },

      hourList: function (hourList) {
        if (this.backupState.pickedHour) {
          for (let i in hourList) {
            if (this.pickedHour.value === hourList[i].value) {
              this.pickedHour = hourList[i]
              this.$refs.smoothPicker.setGroupData(1, Object.assign({}, this.data[1], {
                list: hourList,
                currentIndex: Number(i)
              }))
              this.backupState.pickedHour = null
              // if (this.$store.getters.outletSettings.accept_today === true) {
              //   this.updateStore({})
              // }
              return
            }
          }
          this.backupState.pickedHour = null
        }

        this.$refs.smoothPicker.setGroupData(1, Object.assign({}, this.data[1], {list: hourList}))
        this.pickedHour = hourList[0]
        // if (this.$store.getters.outletSettings.accept_today === true) {
        //   this.updateStore({})
        // }
      },

      timeList: function (timeList) {
        if (this.backupState.pickedTime) {
          for (let i in timeList) {
            if (this.pickedTime.value === timeList[i].value) {
              this.pickedTime = timeList[i]
              this.$refs.smoothPicker.setGroupData(2, Object.assign({}, this.data[2], {
                list: timeList,
                currentIndex: Number(i)
              }))
              this.backupState.pickedTime = null
              if (this.$store.getters.outletSettings.accept_today === true) {
                this.updateStore({ifEmpty: true})
              }
              return
            }
          }
          this.backupState.pickedTime = null
        }

        if (this.pickedTime && this.pickedTime.value) {
          for (let i in timeList) {
            if (this.pickedTime.value === timeList[i].value) {
              this.pickedTime = timeList[i]
              this.$refs.smoothPicker.setGroupData(2, Object.assign({}, this.data[2], {
                list: timeList,
                currentIndex: Number(i)
              }))
              if (this.$store.getters.outletSettings.accept_today === true) {
                this.updateStore({ifEmpty: true})
                this.updateStore({ifSooner: true})
              }
              return
            }
          }
        }

        this.pickedTime = timeList[0]
        this.$refs.smoothPicker.setGroupData(2, Object.assign({}, this.data[2], {list: timeList, currentIndex: 0}))
        if (this.$store.getters.outletSettings.accept_today === true) {
          this.updateStore({ifEmpty: true})
          this.updateStore({ifSooner: true})
        }
      }


    },

    computed: {
      buttonText() {
        if (!this.pickedTime || !this.pickedHour || !this.pickedDay) {
          return ''
        }

        if (this.pickedTime.asap === true && this.isOutletCanStartPrepareOrderNow()) {
          return this.text('screen_form_as_fast_as_you_can')
        }

        return this.pickedDay.value + ' ' + this.text('screen_form_at_time', {'time': this.pickedTime.label})

      },
      ...mapGetters(['language', 'time'])
    },

    mounted() {

      this.setPickerData()

      this.$store.subscribe(mutation => {
        if (mutation.type === SET_MODAL && mutation.payload.modal === 'time') {
          if (mutation.payload.status === true) {
            this.style.display = 'flex' // костыль для smooth-picker
          }
        }
        if (mutation.type === SET_TIMES) {
          this.setPickerData()
        }
      })
    },

    methods: {
      getNearestOrderPreparationDate() {
        const orderPreparationAvailableDates = this.$store.getters.outletSettings.delivery_time.days
        let nearestOrderPreparationDate = null

        if (!orderPreparationAvailableDates || !Object.entries(orderPreparationAvailableDates).length) {
          return null
        }

        for (const [day, timeList] of Object.entries(orderPreparationAvailableDates)) {
          if (timeList.length) {
            const firstAvailablePeriod = timeList[0]
            const isIntervalModeEnabled = firstAvailablePeriod.includes('-')
            const firstAvailableTime = isIntervalModeEnabled ? firstAvailablePeriod.substring(0, firstAvailablePeriod.indexOf('-')).trim() : firstAvailablePeriod
            const dateNotFormatted = `${day} ${firstAvailableTime}`
            const timezoneOffset = this.$store.getters.outletSettings.timezone_offset
            nearestOrderPreparationDate = moment(dateNotFormatted).utcOffset(timezoneOffset, true)
            break
          }
        }

        return nearestOrderPreparationDate
      },

      isOutletCanStartPrepareOrderNow() {
        const orderPreparationInterval = 5 // интервал между заказами (фикс, 5 мин)
        const orderPreparationTime = orderPreparationInterval + (+this.getMinutes() || 0) // ближайший заказ возможен не менее, чем через (мин)
        const desiredOrderPreparationDate = moment().add(orderPreparationTime, 'minute') // желаемая клиентом ближайшая дата заказа
        let nearestOrderPreparationDate = this.getNearestOrderPreparationDate()  // возможная ближайшая дата приготовления рестораном

        if (!nearestOrderPreparationDate) {
          return false
        }

        return desiredOrderPreparationDate.isAfter(nearestOrderPreparationDate)
      },

      getMinutes() {
        if (this.isDelivery) {
          if (this.$store.getters.outletSettings.avg_delivery_time) {
            return this.$store.getters.outletSettings.avg_delivery_time
          }
          return null
        } else {
          if (this.$store.getters.outletSettings.avg_cooking_time) {
            return this.$store.getters.outletSettings.avg_cooking_time
          }
          return null
        }
      },

      setPickerData() {
        if (this.$store.getters.outletSettings.delivery_time.today.length === 0 && this.$store.getters.outletSettings.delivery_time.tomorrow.length === 0) {
          return
        }
        this.dayList = []

        this.backupState.pickedDay = this.pickedDay
        this.backupState.pickedHour = this.pickedHour
        this.backupState.pickedTime = this.pickedTime

        if (this.$store.getters.outletSettings.accept_today === true) {

          if (this.$store.getters.outletSettings.delivery_time.today.length !== 0) {
            this.dayList.push({
              value: this.text('screen_form_today'),
              data: moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).date()
            })
          }
          // if (this.$store.getters.outletSettings.delivery_time.tomorrow.length !== 0) {
          //   this.dayList.push({
          //     value: this.text('screen_form_tomorrow'),
          //     data: moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(1, 'd').date()
          //   })
          // }

          this.pickedDay = this.dayList[0]

        } else {

          let date = moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).locale(this.language)
          date.add(this.$store.getters.outletSettings.accept_day_shift, 'd')

          let label = null
          if (this.$store.getters.outletSettings.delivery_time.today.length !== 0) {
            label = this.$options.filters.capitalize(date.format('MMMM')) + ' ' + date.date() + ' (' + date.format('dd') + ')'
            this.dayList.push({value: label, data: date.date()})
          }

          date.add(1, 'd')

          // if (this.$store.getters.outletSettings.delivery_time.tomorrow.length !== 0) {
          //   label = this.$options.filters.capitalize(date.format('MMMM')) + ' ' + date.date() + ' (' + date.format('dd') + ')'
          //   this.dayList.push({value: label, data: date.date()})
          // }

        }

        this.updateStore({ifEmpty: true})
      },

      updateStore({ifEmpty = false, ifSooner = false}) {
        if (this.$store.getters.deliveryTimeMode !== this.$store.getters.DELIVERY_ONE_DAY) {
          return
        }
        if (ifEmpty === true) {
          if (this.$store.getters.deliveryTimeObject.time.data !== null ||
            this.$store.getters.deliveryTimeObject.day.data !== null) {
            return
          }
        }
        if (ifSooner === true) {
          if (this.$store.getters.deliveryTimeObject.time.data >= this.soonestTime().unix()) {
            return
          }
        }
        this.$store.commit(SET_DELIVERY_TIME_OBJECT, {
          day: this.pickedDay,
          time: this.pickedTime,
          month: {value: null, data: null}
        })
      },

      soonestTime() {
        let time = moment().utcOffset(this.$store.getters.outletSettings.timezone_offset)
        let key, temp
        if (this.$store.getters.outletSettings.delivery_time.today.length !== 0) {
          key = 'today'
        } else if (this.$store.getters.outletSettings.delivery_time.tomorrow.length !== 0) {
          key = 'tomorrow'
          time = time.add(1, 'd')
        } else {
          return null
        }
        if (this.$store.getters.outletSettings.accept_today !== true) {
          time = time.add(this.$store.getters.outletSettings.accept_day_shift, 'd')
        }

        if (this.$store.getters.timeFormat12) {
          temp = moment(this.$store.getters.outletSettings.delivery_time[key][0], 'h:mm A')
        } else {
          temp = moment(this.$store.getters.outletSettings.delivery_time[key][0], 'HH:mm')
        }

        time.hour(temp.hour())
        time.minute(temp.minute())
        time.second(0)

        return time
      },

      pick() {
        this.updateStore({})
        this.close()
      },

      close() {
        this.$store.commit(SET_MODAL, {modal: 'time', status: false})
      },

      dataChange(group, itemIndex) {
        if (group === 0) {
          this.pickedDay = this.dayList[itemIndex]
        }
        if (group === 1) {
          this.pickedHour = this.hourList[itemIndex]
        }
        if (group === 2) {
          this.pickedTime = this.timeList[itemIndex]
        }
      }
    }

  }
</script>
